import { useFormFieldError } from '../../hooks/useFormFieldError';
import {
  Choice,
  SearchableMultiSelect as SearchableMultiSelectBase,
} from '../SearchableMultiSelect';
import { FormFieldWrapper } from './FormFieldWrapper';

interface Props<C extends Choice> {
  className?: string;
  choices: C[];
  defaultValues?: string[];
  inputValue?: string[];
  value?: string[];
  label: string;
  name: string;
  placeholder?: string;
  searchPlaceholder?: string;
  renderChoice?(choice: C): React.ReactNode;
  explanation?: string;
  required?: boolean;
  minSelections?: number;
  maxSelections?: number;
  maxVisibleSelections?: number;
  onChange?(values: string[]): void;
}

export function SearchableMultiSelect<C extends Choice>(props: Props<C>) {
  const { fieldError, showError } = useFormFieldError(props.name);
  const { className, label, explanation, ...rest } = props;

  const shouldShowError =
    showError && (!props.defaultValues || props.defaultValues.length === 0);

  return (
    <FormFieldWrapper
      label={label}
      explanation={explanation}
      fieldError={fieldError}
      showError={shouldShowError}
      className={className}
    >
      <SearchableMultiSelectBase {...rest} />
    </FormFieldWrapper>
  );
}
